import { render, staticRenderFns } from "./AltMenu.vue?vue&type=template&id=419f15fc&"
import script from "./AltMenu.vue?vue&type=script&lang=js&"
export * from "./AltMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports